import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Login from "./Login";
import Home from "./Home";
import FormBuilder from "./Form_builder";
import FormBuilderLayout from "./FormBuilderLayout";
import PublishedForm from "./PublishedForm";
import Responses from "./Responses";
import Preview from "./Preview";
import Share from "./Share";
import Workflow from "./Workflow";
import Settings from "./Settings";
import Templates from "./Templates";
import Landing_pg from "./Landing_pg";
import { DNewsAlertHost } from "./utils/dNews_Alert";
import { UnsavedChangesProvider } from "./utils/UnsavedChangesContext";
import ThemeScope from "./theme/ThemeScope";
import AdminPreview from "./AdminPreview";

// Every route except /login is wrapped in ThemeScope (the dForms theme).
function App() {
  return (
    <>
    <DNewsAlertHost />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/Landing_pg" element={<ThemeScope><Landing_pg /></ThemeScope>} />

      {/* Normal layout */}
      <Route
        path="/home"
        element={
          <ThemeScope>
            <Layout>
              <Home />
            </Layout>
          </ThemeScope>
        }
      />

      {/* ✅ Form Builder uses custom header */}
      <Route
        path="/form-builder"
        element={
          <ThemeScope><UnsavedChangesProvider><FormBuilder /></UnsavedChangesProvider></ThemeScope>
        }
      />
      <Route
        path="/form-builder/:template"
        element={
          <ThemeScope><UnsavedChangesProvider><FormBuilder /></UnsavedChangesProvider></ThemeScope>
        }
      />
      <Route path="/form-builder/view/:token" element={
          <ThemeScope><UnsavedChangesProvider><FormBuilder /></UnsavedChangesProvider></ThemeScope>
        } />

      {/* ✅ Preview route */}
      <Route
        path="/preview/:token/:deviceParams"
        element={
          <ThemeScope>
            <FormBuilderLayout>
              <Preview />
            </FormBuilderLayout>
          </ThemeScope>
        }
      />

      {/* ✅ Workflow route */}
      <Route
        path="/workflow/:token"
        element={
          <ThemeScope>
            <FormBuilderLayout>
              <Workflow />
            </FormBuilderLayout>
          </ThemeScope>
        }
      />

      {/* ✅ Share route */}
      <Route
        path="/Share/:token"
        element={
          <ThemeScope>
            <FormBuilderLayout>
              <Share />
            </FormBuilderLayout>
          </ThemeScope>
        }
      />

      {/* Responses page uses default layout */}
      <Route
        path="/responses/:token"
        element={
          <ThemeScope>
            <FormBuilderLayout>
              <Responses />
            </FormBuilderLayout>
          </ThemeScope>
        }
      />

      {/* ✅ settings route */}
      <Route
        path="/Settings/:formId"
        element={
          <ThemeScope>
            <Settings />
          </ThemeScope>
        }
      />

      {/* Published form (no layout) */}
      <Route path="/forms/:token" element={<ThemeScope><PublishedForm /></ThemeScope>} />

      {/* ✅ Templates route */}
      <Route
        path="/Templates/:formId/:pageId"
        element={
          <ThemeScope>
            <Templates />
          </ThemeScope>
        }
      />

      {/* Read-only preview opened from dAdmin (signed, expiring link; no sign-in) */}
      <Route path="/admin-preview/:token" element={<ThemeScope><AdminPreview /></ThemeScope>} />

      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
    </>
  );
}

export default App;